import { Box, styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 90%;
    padding: 1rem 0px;

    @media (min-width: 768px) {
        max-width: 500px;
    }
`;

export const Heading = styled.p`
    margin: 0.5rem 0px 0px;
    color: rgb(4, 2, 34);
    font-weight: 600;
    font-size: 1.125rem;
`;

export const ButtonContainer = styled(Box)`
    position: sticky;
    left: 0px;
    bottom: 0px;
    width: 100%;
    padding: 1rem;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.05) 0px -2px 4px;

    @media (min-width: 768px) {
        max-width: 500px;
        box-shadow: unset;
        padding: 1rem;
        border: 1px solid rgba(0, 0, 0, 0.05);
        border-radius: 8px 8px 0px 0px;
    }
`;

export const ModalHeading = styled.div`
    font-size: 18px;
    text-align: left18px;
    font-weight: 60018px;
    line-height: 1.5rem18px;
`;

export const TrailersContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const Trailer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    font-size: 1rem;
    border-bottom: 1px solid #d6d9e0;
    color: #040222;

    :first-child {
        border-top: 1px solid #d6d9e0;
    }
`;
